import { render } from "./ChooseTaskStatus.vue?vue&type=template&id=2a1e93b4&scoped=true"
import script from "./ChooseTaskStatus.vue?vue&type=script&lang=js"
export * from "./ChooseTaskStatus.vue?vue&type=script&lang=js"

import "./ChooseTaskStatus.vue?vue&type=style&index=0&id=2a1e93b4&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1e93b4"]])

export default __exports__